/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchCalendarDetailForNextBookingQueryVariables = Exact<{
  guid: string | number;
}>;


export type FetchCalendarDetailForNextBookingQuery = { calendarDetail:
    | { __typename: 'CalendarDetailNotFound', message: string }
    | { __typename: 'CalendarDetailPermissionDenied', message: string }
    | { __typename: 'CalendarDetailSuccess', calendar: { guid: string, privateTitle: string | null, publicTitle: string } }
   };

export type FetchPreviousBookingQueryVariables = Exact<{
  guid: string | number;
}>;


export type FetchPreviousBookingQuery = { bookingV2:
    | { __typename: 'Booking', summary: string | null }
    | { __typename: 'BookingErrorNotFound', message: string }
    | { __typename: 'BookingErrorPermissionDenined', message: string }
   };

export type NextBookWithCalendarByEntranceMutationVariables = Exact<{
  calendarGUID: string | number;
  previousBookingGUID: string | number;
  startsAt: TimeString;
  endsAt: TimeString;
}>;


export type NextBookWithCalendarByEntranceMutation = { bookWithCalendarByEntrance:
    | { __typename: 'BookWithCalendarByEntranceErrorAlreadyReserved', message: string }
    | { __typename: 'BookWithCalendarByEntranceErrorV2User' }
    | { __typename: 'BookWithCalendarByEntranceSuccess', unit: any }
   | null };


export const FetchCalendarDetailForNextBookingDocument = gql`
    query FetchCalendarDetailForNextBooking($guid: ID!) {
  calendarDetail(guid: $guid) {
    __typename
    ... on CalendarDetailSuccess {
      calendar {
        guid
        privateTitle
        publicTitle
      }
    }
    ... on CalendarDetailNotFound {
      message
    }
    ... on CalendarDetailPermissionDenied {
      message
    }
  }
}
    `;

/**
 * __useFetchCalendarDetailForNextBookingQuery__
 *
 * To run a query within a Vue component, call `useFetchCalendarDetailForNextBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCalendarDetailForNextBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCalendarDetailForNextBookingQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useFetchCalendarDetailForNextBookingQuery(variables: FetchCalendarDetailForNextBookingQueryVariables | VueCompositionApi.Ref<FetchCalendarDetailForNextBookingQueryVariables> | ReactiveFunction<FetchCalendarDetailForNextBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables>(FetchCalendarDetailForNextBookingDocument, variables, options);
}
export function useFetchCalendarDetailForNextBookingLazyQuery(variables?: FetchCalendarDetailForNextBookingQueryVariables | VueCompositionApi.Ref<FetchCalendarDetailForNextBookingQueryVariables> | ReactiveFunction<FetchCalendarDetailForNextBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables>(FetchCalendarDetailForNextBookingDocument, variables, options);
}
export type FetchCalendarDetailForNextBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCalendarDetailForNextBookingQuery, FetchCalendarDetailForNextBookingQueryVariables>;
export const FetchPreviousBookingDocument = gql`
    query FetchPreviousBooking($guid: ID!) {
  bookingV2(guid: $guid) {
    __typename
    ... on Booking {
      summary
    }
    ... on BookingErrorNotFound {
      message
    }
    ... on BookingErrorPermissionDenined {
      message
    }
  }
}
    `;

/**
 * __useFetchPreviousBookingQuery__
 *
 * To run a query within a Vue component, call `useFetchPreviousBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPreviousBookingQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchPreviousBookingQuery({
 *   guid: // value for 'guid'
 * });
 */
export function useFetchPreviousBookingQuery(variables: FetchPreviousBookingQueryVariables | VueCompositionApi.Ref<FetchPreviousBookingQueryVariables> | ReactiveFunction<FetchPreviousBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables>(FetchPreviousBookingDocument, variables, options);
}
export function useFetchPreviousBookingLazyQuery(variables?: FetchPreviousBookingQueryVariables | VueCompositionApi.Ref<FetchPreviousBookingQueryVariables> | ReactiveFunction<FetchPreviousBookingQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables>(FetchPreviousBookingDocument, variables, options);
}
export type FetchPreviousBookingQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchPreviousBookingQuery, FetchPreviousBookingQueryVariables>;
export const NextBookWithCalendarByEntranceDocument = gql`
    mutation NextBookWithCalendarByEntrance($calendarGUID: ID!, $previousBookingGUID: ID!, $startsAt: Time!, $endsAt: Time!) {
  bookWithCalendarByEntrance(
    calendarGUID: $calendarGUID
    previousBookingGUID: $previousBookingGUID
    startsAt: $startsAt
    endsAt: $endsAt
  ) {
    __typename
    ... on BookWithCalendarByEntranceSuccess {
      unit
    }
    ... on BookWithCalendarByEntranceErrorAlreadyReserved {
      message
    }
  }
}
    `;

/**
 * __useNextBookWithCalendarByEntranceMutation__
 *
 * To run a mutation, you first call `useNextBookWithCalendarByEntranceMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useNextBookWithCalendarByEntranceMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useNextBookWithCalendarByEntranceMutation({
 *   variables: {
 *     calendarGUID: // value for 'calendarGUID'
 *     previousBookingGUID: // value for 'previousBookingGUID'
 *     startsAt: // value for 'startsAt'
 *     endsAt: // value for 'endsAt'
 *   },
 * });
 */
export function useNextBookWithCalendarByEntranceMutation(options: VueApolloComposable.UseMutationOptions<NextBookWithCalendarByEntranceMutation, NextBookWithCalendarByEntranceMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<NextBookWithCalendarByEntranceMutation, NextBookWithCalendarByEntranceMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<NextBookWithCalendarByEntranceMutation, NextBookWithCalendarByEntranceMutationVariables>(NextBookWithCalendarByEntranceDocument, options);
}
export type NextBookWithCalendarByEntranceMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<NextBookWithCalendarByEntranceMutation, NextBookWithCalendarByEntranceMutationVariables>;